import client from "./sharedoClient";
import queryString from "@/util/queryStringGenerator"
import { DEFAULT_TEMPLATE_REPOSITORY } from "@/constants/documentGeneration";

const getViewingSession = (template, repository = DEFAULT_TEMPLATE_REPOSITORY) => client.get(`api/wordaddin/prizm/viewingSession/${repository}/${template}`);

const getPageAttributes = (viewingSessionId, page) => {
    const qs = { DocumentID: `u${viewingSessionId}`, };  // This is case sensitive!  

    return client.get(`api/prizm-proxy/Page/q/${page}/Attributes${queryString.generate(qs)}`);
}

const getPageImage = async (viewingSessionId, page, scale, contentType) => {
    const qs = {
        DocumentID: `u${viewingSessionId}`,
        Scale: scale,
        Quality: 85,
        ContentType: contentType
    };

    const blob = await client.getBlob(`api/prizm-proxy/Page/q/${page}${queryString.generate(qs)}`);

    return URL.createObjectURL(blob);
}

export default {
    getViewingSession,
    getPageAttributes,
    getPageImage
}